import { Link } from "react-router-dom";

interface FooterLink {
  label: string;
  href: string;
  external?: boolean;
}

interface LandingFooterProps {
  extraLinks?: FooterLink[];
}

const LandingFooter = ({ extraLinks }: LandingFooterProps) => {
  const defaultLinks: FooterLink[] = [
    { label: "How It Works", href: "/#how-it-works" },
    { label: "Features", href: "/#features" },
    { label: "FAQ", href: "/#faq" },
    { label: "Free SEO Audit", href: "/tools/free-seo-audit" },
    { label: "Login", href: "/login" },
    { label: "Sitemap", href: "/sitemap.xml", external: true },
  ];

  const allLinks = [...defaultLinks, ...(extraLinks ?? [])];

  return (
    <footer className="border-t border-border py-10">
      <div className="container mx-auto px-6 flex flex-col items-center gap-8 text-sm text-muted-foreground">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 w-full">
          <div className="flex flex-col items-center gap-1">
            <img
              src="/Unranked-agency-logo.png"
              alt="Unranked Agency"
              className="h-6 w-auto object-contain"
            />
            <span className="text-muted-foreground">AI-powered SEO &amp; visibility analysis</span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6">
            {allLinks.map((l) =>
              l.external ? (
                <a key={l.href} href={l.href} className="hover:text-foreground transition-colors">
                  {l.label}
                </a>
              ) : (
                <Link key={l.href} to={l.href} className="hover:text-foreground transition-colors">
                  {l.label}
                </Link>
              )
            )}
          </div>
        </div>

        <span className="border-t border-border pt-4 w-full text-center">
          © {new Date().getFullYear()} Unranked Agency. All rights reserved.
        </span>
      </div>
    </footer>
  );
};

export default LandingFooter;
